/* ==========================================================================
   WARRIOR basket page (sections/custom-cart.liquid).
   Every control posts to /cart/change.js, then the page reloads, so the page,
   the header count and the UpCart drawer all read the same cart.
     - qty − / + and Remove
     - "Delivered: Every …" select   → change the line's selling plan
     - "Put this On repeat" tick box → add a selling plan (line moves to On repeat)
     - "Switch to one-time"          → remove the selling plan
   The drawer can change the cart while this page is open; any cart write that
   did not come from here also reloads the page once it settles.
   ========================================================================== */
(function () {
  'use strict';
  var root = document.querySelector('[data-custom-cart]');
  if (!root) return;

  var own = false;
  var reloadTimer = null;

  function busy(on) {
    root.classList.toggle('is-busy', on);
    root.setAttribute('aria-busy', on ? 'true' : 'false');
  }
  function fail(msg) {
    busy(false);
    var box = root.querySelector('[data-cart-error]');
    if (!box) {
      box = document.createElement('p');
      box.setAttribute('data-cart-error', '');
      box.setAttribute('role', 'alert');
      box.className = 'custom-cart__error';
      root.insertBefore(box, root.firstChild);
    }
    box.textContent = msg || 'That did not work. Please try again.';
  }
  function change(body) {
    own = true;
    busy(true);
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message);
        window.location.reload();
      });
    }).catch(function (e) { own = false; fail(e.message); });
  }
  function lineOf(el) {
    var l = el.closest('[data-line-key]');
    return l ? { key: l.getAttribute('data-line-key'), qty: parseInt(l.getAttribute('data-quantity'), 10) || 1 } : null;
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-qty], [data-remove], [data-plan-remove]');
    if (!t || root.classList.contains('is-busy')) return;
    var l = lineOf(t);
    if (!l) return;
    if (t.hasAttribute('data-qty')) {
      change({ id: l.key, quantity: Math.max(0, l.qty + parseInt(t.getAttribute('data-qty'), 10)) });
    } else if (t.hasAttribute('data-remove')) {
      change({ id: l.key, quantity: 0 });
    } else {
      change({ id: l.key, quantity: l.qty, selling_plan: null });
    }
  });

  root.addEventListener('change', function (e) {
    var t = e.target;
    var l = lineOf(t);
    if (!l) return;
    if (t.matches('[data-plan-select]')) {
      change({ id: l.key, quantity: l.qty, selling_plan: parseInt(t.value, 10) });
    } else if (t.matches('[data-plan-add]') && t.checked) {
      change({ id: l.key, quantity: l.qty, selling_plan: parseInt(t.getAttribute('data-plan-add'), 10) });
    }
  });

  // Mobile sticky bar: hide it while the ticket's own checkout or the footer is on screen.
  var bar = root.querySelector('.custom-cart__stickybar');
  if (bar && 'IntersectionObserver' in window) {
    var seen = new Set();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { en.isIntersecting ? seen.add(en.target) : seen.delete(en.target); });
      bar.classList.toggle('is-hidden', seen.size > 0);
    });
    [root.querySelector('.custom-cart__checkout:not(.custom-cart__checkout--sm)'), document.querySelector('footer, .shopify-section-group-footer-group')]
      .forEach(function (el) { if (el) io.observe(el); });
  }

  // Keep the page in step with the drawer: a cart write we did not make → reload.
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  function external(url) {
    if (own || !CART_WRITE.test(String(url || ''))) return;
    clearTimeout(reloadTimer);
    reloadTimer = setTimeout(function () { window.location.reload(); }, 600);
  }
  if (window.fetch) {
    var f = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url);
      return f.apply(this, arguments).then(function (res) { external(url); return res; });
    };
  }
  var open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.addEventListener('loadend', function () { external(url); });
    return open.apply(this, arguments);
  };
})();
